import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Optional, Output, SimpleChanges, OnInit } from '@angular/core';
import { IPSAuthenticationService, IPSObservabilityService } from '@ips/common-angular';
import { DocumentItemList1 } from 'com.trumbull.phx.document.api-client';
import { ButtonModule } from 'primeng/button';
import { PanelModule } from 'primeng/panel';
// import { LoaderComponent } from '../../../loader/loader.component';
import { DocumentProcessingService } from '../../../services/document-processor/document-processor.service';
// import { LoaderService } from '../../../services/loader-service/loader.service';
import { OrderDetails } from '../order-details.model';
import { RootObject } from '../orders.model';
import { DocumentReference } from '../record-index-table/record-index-table.component';


@Component({
  selector: 'app-order-details-general-information',
  imports: [PanelModule, CommonModule, ButtonModule],
  templateUrl: './order-details-general-information.component.html',
  styleUrl: './order-details-general-information.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DatePipe]
})
export class OrderDetailsGeneralInformationComponent implements OnChanges, OnInit  {
  @Input() orderDetails?: OrderDetails;
  @Input() orderData?: RootObject;
  @Input() documents?: (DocumentItemList1 | undefined)[];
  @Input() vocabDocumentTagsData: any = [];
  @Output() tableAction = new EventEmitter();
  @Input() isUserLinkedToAccount: boolean = false;
  @Input() requestDocuments?: { requestNumber: string; documentList: any[] }[];
  requestDocumentsMap = new Map<string, any[]>();
  constructor(
    // private readonly loaderService: LoaderService,
    private readonly documentProcessor: DocumentProcessingService,
    @Optional() private readonly observability: IPSObservabilityService,
    private readonly authService: IPSAuthenticationService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['documents']) {
      const documentPattern = /^Order Documents$/;
      if (this.documents && this.documents.length > 0 && this.orderDetails) {
        const processedDocs = this.documentProcessor.filterDocumentReferences(this.documents || [], documentPattern);

        // FIXME: See if you can line this up with the document processor matchRequestsToDocuments
        if (processedDocs.processedDocs && processedDocs.processedDocs.length > 0) {
          this.orderDetails.attachmentInfo = processedDocs.processedDocs.flatMap(doc => {
            return doc?.lists?.flatMap(list => {
              const matchingItems = doc?.documentItems?.filter(item =>
                item.documentListId === list.id
              ) || [];

              return matchingItems.map(item => ({
                fileName: item.displayName,
                documentListId: list.id,
                documentId: item.id,
                documentItems: [item],
                tagName: this.getTagName(item.tags),
                description: this.getDocTitleDescription(item.description, this.vocabDocumentTagsData)
              }));
            }) ?? [];
          }) as DocumentReference[];
        }


        this.observability?.trackEvent('document:processing:generalInfo:attachments:mapped', {
          totalDocumentLists: processedDocs.processedDocs.length,
          totalAttachments: this.orderDetails.attachmentInfo.length,
        });

        this.observability?.trackEvent('document:processing:generalInfo:filter:results', processedDocs.stats);
      }
    }
    if (this.requestDocuments?.length) {
        this.requestDocumentsMap.clear();

        for (const doc of this.requestDocuments) {
          // Use the full requestNumber (e.g. "001", "001-01") as the key so parent
          // and child requests remain distinct and align with the provider map key.
          if (doc.requestNumber != null) {
            this.requestDocumentsMap.set(String(doc.requestNumber), doc.documentList);
          }
        }
    }
  }

  getTagName(tags: any): string{
    if (tags.length > 0 ){
      return tags[0].tagName;
    }
    return " ";
  }

  ngOnInit(): void {
  }

  downloadFile(file: DocumentReference) {
    this.tableAction.emit({ action: 'downloadSingleFile', data: file });
  }

  downloadRequestFile(file: any){
    this.tableAction.emit({ action: 'downloadSingleFile', data: file });
  }

  getPlaintiffNames(counsel: any): string {
    if (!counsel?.plaintiffs?.length) return '--';
    return counsel.plaintiffs.map((p: any) => p.name).join(', ');
  }

  getDefendantNames(defendant: any): string {
    if (!defendant?.defendants?.length) return '--';
    return defendant.defendants.map((d: any) => d.name).join(', ');
  }

  keepOriginalSorting = () => 0;

  trackByKey(index: number, item: any): string {
    return item.key;
  }

  getDocTitleDescription(title: string = '', vocabData: any) {
    const vocabTitleData = vocabData?.find((d: any) => d.vocabularyName === 'OrderDocumentCode');
    const selectedTitle = vocabTitleData?.vocabularyItems?.find((item: any) => item?.code === title);
    return selectedTitle?.description || title;
  }

  getRequestDocTitleDescription(title: string = '', vocabData: any) {
    const vocabTitleData = vocabData?.find((d: any) => d.vocabularyName === 'RequestDocumentCode');
    const selectedTitle = vocabTitleData?.vocabularyItems?.find((item: any) => item?.code === title);
    return selectedTitle?.description || title;
  }

  getRequestDocTitleTagName(document: any, vocabData: any) {
      let label = "  ";
      if (document && document.tags.length > 0) {
        label = document.tags[0].tagName;
        const vocabTitleData = vocabData?.find((d: any) => d.vocabularyName === 'RequestDocumentCode');
        const selectedTitle = vocabTitleData?.vocabularyItems?.find((item: any) => item?.code === label);
        label = selectedTitle?.description || label;
      }
      return label;
  }
}
